<div class="row col-12 p-0 m-0 main-page-section ">
  <!-- <div class="p-0">
    <app-side-nav [item]="meetingNav"></app-side-nav>
  </div> -->
  <div class="col-12 p-0">
    <!-- <app-header></app-header> -->


    <div>
      <div class="breadcrumbs-section margin-bottom-40">
        <span class="prev-page pr-1 breadcrumbs-section-font prev" routerLink="/overview">Home</span>
        <span class="separator">&nbsp; > &nbsp;</span>
        <span class="prev-page pl-1 breadcrumbs-section-font prev" routerLink="/employees/employees-list">Employees
        </span>
        <span class="separator">&nbsp; > &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">Bulk Upload employees</span>
      </div>
      <div class="d-flex col-12 mt-5 justify-content-between meetings-layout">
        <div class="col-9 margin-left-20">
          <div class="flex-column d-flex">
            <div class="meetings mt-3">Bulk Upload employees</div>
            <div *ngIf="bulkUploadProcessStep" class="mt-2">
              <span *ngIf="bulkUploadSuccessMsg" class="bu-result-sucessMsg">{{successCount}} Employees uploaded.</span>
              <span *ngIf="bulkUploadUnSuccessMsg" class="bu-result-ErrorMsg ">
                {{failuresCount}} errors found. Please make changes in the excel sheet & re-upload them to save to
                database.
              </span>
            </div>
          </div>
        </div>

        <div class="col-3 re-upload" *ngIf="bulkUploadProcessStep">
          <div class="flex-column d-flex">
            <label class="upload-button mt-4" for="reuploadfile-input">
              <img src="/assets/images/add-excel.png" loading="lazy" />
              <span class="upload"> Re-upload Excel Sheet here</span>
              <!--*ngIf="!fileName" -->

            </label>
            <input id="reuploadfile-input" type="file" accept=".csv" (change)="handleFileSelect($event)" />
          </div>
        </div>
      </div>
    </div>


    <div class="col-height">

      <div *ngIf="bulkUploadInputStep">
        <div class="d-flex col-12 mt-5 meetings-layout">
          <div class="col-6 step-one">
            <div class="rectangle ">
              <span class="step">Step 1</span>
            </div>
            <div class="flex-column d-flex">
              <span class="mt-3 bulk-sub-heading">Bulk Upload Employees</span>
              <span class="mt-2 notes">We have created a format to help you input employee data that will make it easier
                to upload information. Please download the the below excel sheet to fill in your employee data.</span>
              <!-- <span><button class="add-button add mt-4">
                  <img class="image-pos " src="/assets/images/excel.png" alt="search" loading="lazy">
                  Download Excel Sheet</button></span> -->
              <div class="excel-downloader"><img class="image-pos " src="/assets/images/excel.png" alt="search"
                  loading="lazy"><a class="excel-downloader-title" [attr.href]="templateUrl">Download Excel Sheet
                  here</a></div>
            </div>

          </div>
          <div class="ml-5 mr-5 verticalLine-details">

          </div>
          <div class="col-6">
            <div class="rectangle ">
              <span class="step">Step 2</span>
            </div>
            <div class="flex-column d-flex">
              <span class="mt-3 bulk-sub-heading">And Upload Here</span>
              <span class="mt-2 notes">Once you have filled in your employee data in the downloaded excel sheet, upload
                the document here.</span>
              <label class="upload-button mt-4" for="file-input">
                <img src="/assets/images/add-excel.png" loading="lazy" />
                <span class="upload"> Upload Excel Sheet here</span>

              </label>

              <input id="file-input" type="file" accept=".csv" (change)="handleFileSelect($event)" />
              <!-- <label for="file-input">
                                      <img class="image-pos " src="/assets/images/add-excel.png" /> Upload Excel Sheet here
                                  </label> -->
              <!-- <input type="file" accept=".csv" (change)="handleFileSelect($event)"> -->
              <!-- <span><button class="upload-button upload mt-5">
                                  <img class="image-pos " src="/assets/images/add-excel.png" alt="search">
                                  Upload Excel Sheet here</button></span> -->
            </div>

          </div>
        </div>
        <div class="meetings-layout mt-5">
          <hr>
        </div>

      </div>


      <div *ngIf="bulkUploadProcessStep">

        <div class="d-flex col-12 mt-5 meetings-layout">
          <div class="col-12 d-flex flex-row bu-result-header">

            <div class="col-1">Sr.No</div>
            <div class="col-3">Employee Name</div>
            <div class="col-3">Email Id</div>
            <div class="col-2">Contact No.</div>
            <div class="col-3">Department</div>

          </div>
        </div>

        <div class="d-flex col-12 meetings-layout row bu-result-row"
          *ngFor="let member of members index as i; odd as isOdd; even as isEven">

          <div class="col-12 d-flex flex-row" [ngClass]="getRowCssClass(member.isValidRow, isEven, isOdd)">
            <div class="col-1 row-outer-text">
              <div class="slno-text row-inner-text">{{member?.srNo}}</div>
            </div>
            <div class="col-3 row-outer-text">
              <div class="row-inner-text">{{member?.employeeName}}</div>
            </div>
            <div class="col-3 row-outer-text">
              <div class="row-inner-text">{{member?.emailId}}</div>
            </div>
            <div class="col-2 row-outer-text">
              <div class="row-inner-text">{{member?.contactNumber}}</div>
            </div>
            <div class="col-3 row-outer-text">
              <div class="row-inner-text">{{member?.department}}</div>
            </div>
          </div>

          <div *ngIf="!member.isValidRow" class="col-12 d-flex flex-row error-row-display">
            <div class="col-1">&nbsp;</div>
            <div class="col-3">
              <div class="error-text">
                <span>{{member.validationIssues[0]}}</span>

                <span *ngIf="!member.isValidEmployee">
                  member already exists.
                </span>
              </div>
            </div>
            <div class="col-3 row-outer-text">
              <div class="error-text">{{member.validationIssues[1]}}</div>
            </div>
            <div class="col-2 row-outer-text">
              <div class="error-text">{{member.validationIssues[2]}}</div>
            </div>
            <div class="col-3 row-outer-text">
              <div class="error-text">{{member.validationIssues[3]}}</div>
            </div>
          </div>


        </div>

        <div *ngIf="bulkUploadSuccessMsg" class="d-flex col-12 mt-3 meetings-layout-result">

          <div class="d-flex col-12 ">
            <div class="col-10 d-flex">
              <span class="bu-result-sugMsg">{{successCount}} employees will receive invitation mail.</span>
            </div>
            <div class="col-2 d-flex">
              <label class="upload-button-invitation mt-4" for="sendInvite" (click)="sendInvitation($event)">
                <span class="upload-button-text"> Send Invite</span>

              </label>
            </div>
          </div>

        </div>
      </div>


      <div *ngIf="bulkUploadResultStep" class="d-flex col-12 mt-5 meetings-layout">
        <div class="">
          <div class="meetings-layout">
            <div class="row mt-3 success-height">
              <img class="image-width" src="assets/images/success-tick.png">
              <div class="d-flex flex-column pl-4 pt-1">
                <span class="successfully-added">
                  Upload successful
                </span>
                <span class="employee-profiles-text">
                  Employee profiles successfully created.
                </span>
                <span class="view-employees mt-3" (click)="viewEmployeeList()">
                  View Employees
                </span>

              </div>

            </div>

          </div>
        </div>
      </div>

    </div>




  </div>
</div>
